export default "__VITE_ASSET__CX$3MAHX__"